import { IFormSchemaField, IFormValidationRule } from "../types";

/** A field is "required" for input affordances if it carries a `Required` rule. */
export const isFieldRequired = (field: IFormSchemaField): boolean =>
  field.validation.rules.some(rule => rule.kind === "Required");

/**
 * `ui.component === "Hidden"` — the field participates in the engine pipelines
 * and wire (worksheet intermediates) but the FE renders nothing. Its value must
 * still be RHF-registered so it survives to the submit payload; it must NOT
 * count toward a section/step being "visible" or toward client validation.
 */
export const isHiddenUiField = (field: IFormSchemaField): boolean =>
  field.ui?.component === "Hidden";

/**
 * Server-resolved `operations.disabled` — the input rejects new user input
 * (and a Group's Add button is disabled) but keeps its value registered.
 */
export const isFieldDisabled = (field: IFormSchemaField): boolean =>
  field.operations.disabled === true;

/**
 * Input label with the design's optionality signifier: required fields show no
 * signifier; optional fields get a trailing "(optional)".
 */
export const fieldLabel = (field: IFormSchemaField): string =>
  isFieldRequired(field) ? field.label : `${field.label} (optional)`;

/** Numeric value of the first MinValue rule, if any. */
export const minValueFromRules = (
  rules: IFormValidationRule[]
): number | undefined => {
  const rule = rules.find(r => r.kind === "MinValue");
  return rule && rule.kind === "MinValue" ? rule.value : undefined;
};

/** Numeric value of the first MaxValue rule, if any. */
export const maxValueFromRules = (
  rules: IFormValidationRule[]
): number | undefined => {
  const rule = rules.find(r => r.kind === "MaxValue");
  return rule && rule.kind === "MaxValue" ? rule.value : undefined;
};
